<template>
  <div class="animated fadeIn" id="tab-soldes">
    <b-card no-body>
      <b-card-header>
        <i class="fa fa-list mr-2"></i>
        <strong>Historique des Soldes</strong>
      </b-card-header>
      <b-card-body>
        <v-client-table :columns="columns" :data="items" :options="options">
          <div v-if="props.row.timestamp" slot="timestamp" slot-scope="props" class="slot-date">
            <span class="badge badge-success p-2">{{ formatDate(props.row.timestamp) }}</span>
          </div>
          <div slot="solde" slot-scope="props" class="slot-number" style="font-weight:bold">{{ formatNumber(props.row.solde) }}</div>

          <div v-if="props.row.montant_operations < 0" slot="montant_operations" slot-scope="props" class="slot-number text-nowrap montant-negatif">{{ formatNumber(props.row.montant_operations) }}</div>
          <div v-else slot="montant_operations" slot-scope="props" class="slot-number" nowrap>{{ formatNumber(props.row.montant_operations) }}</div>

          <div v-if="props.row.montant_virements < 0" slot="montant_virements" slot-scope="props" class="slot-number text-nowrap montant-negatif">{{ formatNumber(props.row.montant_virements) }}</div>
          <div v-else slot="montant_virements" slot-scope="props" class="slot-number" nowrap>{{ formatNumber(props.row.montant_virements) }}</div>

          <div v-if="props.row.montant_autres_opes < 0" slot="montant_autres_opes" slot-scope="props" class="slot-number text-nowrap montant-negatif">{{ formatNumber(props.row.montant_autres_opes) }}</div>
          <div v-else slot="montant_autres_opes" slot-scope="props" class="slot-number" nowrap>{{ formatNumber(props.row.montant_autres_opes) }}</div>

        </v-client-table>
      </b-card-body>
    </b-card>
  </div>
</template>

<script>
import { getBaseUrl, getProvider, getIdToken, getAccessToken } from '../../utils/auth'
import {espaceRPARules, hasRule} from '../../utils/rulesHelper'

export default {
  data() {
    return {
      rules: espaceRPARules,
      columns: [
        "timestamp",
        "solde",
        "montant_operations",
        "montant_virements",
        "montant_autres_opes"
      ],
      items: [],
      options: {
        headings: {
          timestamp: "Date",
          solde: "Solde",
          montant_operations: "Montant Opération",
          montant_virements: "Montant Virements",
          montant_autres_opes: "Montant Autres",
        },
        sortable: ["timestamp", "solde","montant_operations","montant_virements","montant_autres_opes"],
        filterable: ["solde","montant_operations","montant_virements","montant_autres_opes"],
        perPage: 30,
        perPageValues: [30, 100, 300],
        texts: {
          filterPlaceholder: "Solde, Montant"
        }
      }
     
    }
  },
  mounted() {
   this.all();
  },
  created() {
    this.$axios.defaults.baseURL = getBaseUrl();
    this.$axios.defaults.headers.common["Authorization"] = getIdToken() + " " + getAccessToken();
    this.$axios.defaults.headers.common["Accept"] = "application/json";
    this.$axios.defaults.headers.common["Provider"] = getProvider();
  },
  methods: {
    canAccess(rule) {
      return hasRule(rule)
    },
    formatNumber(num) {
      return num.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1 ").replace(/\./g, ',');
    },
    formatDate(textDate) {
      let date = textDate !== null ? new Date(textDate).toLocaleDateString("fr-FR") : "-";
      return date;
    },
    all() {
      let self = this;
      this.$store.commit("IS_LOADING", true);
      this.$axios
        .get("/espaceRPA/soldes")
        .then(response => {
          this.$store.commit("IS_LOADING", false);
          this.items = response.data.soldes;
        })
        .catch(function(error) {
          self.$store.commit("IS_LOADING", false);
          self.$swal({
            position: "top",
            type: "error",
            title: "Attention !!",
            text: "Une erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI",
            showConfirmButton: false,
            timer: 5000
          });
        });
    },
  }
}
</script>

<style>
  #tab-soldes .VueTables__table thead tr th:first-child {
    width: 12%;
  }
  #tab-soldes .VueTables__table thead tr th:nth-child(2) {
    width: 22%;
  }
  #tab-soldes .VueTables__table thead tr th:nth-child(3) {
    width: 22%;
  }
  #tab-soldes .VueTables__table thead tr th:nth-child(4) {
    width: 22%;
  }
  #tab-soldes .VueTables__table thead tr th:nth-child(5) {
    width: 22%;
  }

</style>